import React, { useState } from "react";
import { useCart } from "../../../context/CartContext";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import config from "../../../config";

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //const { brandName } = location.state || {};
  const {
    brandName,
    totalAmount: passedTotalAmount,
    subtotal: passedSubtotal,
    totalDiscount: passedTotalDiscount,
    totalGST: passedTotalGST,
    cartItems: passedItems,
    serviceName,
    showMessage,
    orderDiscountMeta,
  } = location.state || {};
  const { cartItems, clearCart, getCartTotal, user, vendorID, guestvendorid } =
    useCart();

  const formatDate = (date) => {
    if (!date) return null;

    // if format like "19 Nov 2025"
    const parts = date.split(" ");
    if (parts.length === 3) {
      const day = parts[0];
      const month =
        [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ].indexOf(parts[1]) + 1;
      const year = parts[2];
      return `${year}-${String(month).padStart(2, "0")}-${day.padStart(
        2,
        "0"
      )}`;
    }

    // fallback for safe Date formats
    const d = new Date(date + "T00:00:00");
    return d.toISOString().split("T")[0];
  };

  // ✅ Corrected calculation logic for grooming & boarding
  //const calculateTotalAmount = () => {
  //return cartItems.reduce((sum, item) => {
  //  const type = (item.service_type || item.item_type || "").toLowerCase();

  // 🏠 Boarding → calculate by nights using unit_price
  // if (["home boarding", "kennel boarding", "pet resort"].includes(type)) {
  //if (item.start_date && item.end_date) {
  //  return sum + (item.unit_price || 0);
  //}
  //  return sum + (item.unit_price || 0);
  //}

  // ✂️ Grooming → use price if available
  //if (
  // ["home grooming", "mobile pet grooming van", "grooming salon"].includes(
  //   type
  // )
  //) {
  // return sum + Number(item.price || item.unit_price || 0);
  //}

  // 📦 Other → quantity-based using unit_price
  // const quantity = item.quantity || 1;
  //return sum + (item.unit_price || 0) * quantity;
  // }, 0);
  //};

  //const totalAmount = calculateTotalAmount();
  const totalAmount = Number(passedTotalAmount || 0);

  const [selectedMethod, setSelectedMethod] = useState("cash");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [orderDetails, setOrderDetails] = useState(null);

  const clientId = user?.client_id;

  // const getItemType = (item) => {
  //   const name = (item.service_type || item.item_type || "").toLowerCase();

  //   if (
  //     ["home grooming", "mobile pet grooming van", "grooming salon"].includes(
  //       name
  //     )
  //   )
  //     return "grooming";

  //   if (["home boarding", "kennel boarding", "pet resort"].includes(name))
  //     return "boarding";

  //   if (["day care services"].includes(name)) return "day_care";
    
  //   if (["dog walking", "dog walking services", "walking", "dog_walking"].includes(name))
  //     return "dog_walking";

  //   // 🩺 Add vet clinic support (handles all possible variations)
  //   if (
  //     [
  //       "pet vet clinic",
  //       "vet clinic",
  //       "veterinary",
  //       "veterinary hospital",
  //       "pet clinic",
  //     ].includes(name)
  //   )
  //     return "vet_clinic";

  //   if (["product"].includes(name)) return "product";

  //   return "other";
  // };

  const calculateItemPrice = (item) => {
    const qty = item.quantity || 1;
    const baseUnitPrice = Number(item.price || item.unit_price || 0);

    // 1. BASE TOTAL
    const baseAmount = baseUnitPrice;

    // 2. ADDONS & SURCHARGES (Summed into the taxable base)
    const addonsTotal = (item.addons || []).reduce(
      (sum, a) => sum + (a.price || 0),
      0
    );
    const surchargeTotal = (
      item.surcharge_details ||
      item.price_surcharge ||
      []
    ).reduce((sum, a) => sum + (a.price || 0), 0);

    const amountWithoutTax = baseAmount + addonsTotal + surchargeTotal;

    // 3. DISCOUNT (Apply before tax)
    const discount = Number(item.discount_amount || item.discount || 0);
    const amountAfterDiscount = Math.max(0, amountWithoutTax - discount);

    // 4. GST (Calculated on the price AFTER discount)
    const taxPercentage = Number(
      item.tax_rate || item.tax_percentage || item.gst || 0
    );
    const taxAmount = (amountAfterDiscount * taxPercentage) / 100;

    // 5. FINAL LINE TOTAL
    const amountWithTax = amountAfterDiscount + taxAmount;

    return {
      qty,
      amountWithoutTax, // Original Subtotal
      discount,
      amountAfterDiscount, // Taxable Base
      taxPercentage,
      taxAmount,
      amountWithTax, // Final Payable for this item
    };
  };
  const calculateCartTotals = (orderItems) => {
    return orderItems.reduce(
      (acc, it) => {
        acc.amountBeforeDiscount += it.amount_without_tax;
        acc.totalTax += it.tax_amount;
        acc.discountAmount += it.discount_amount;
        acc.finalAmount += it.amount_with_tax;
        return acc;
      },
      {
        amountBeforeDiscount: 0,
        totalTax: 0,
        finalAmount: 0,
        discountAmount: 0,
      }
    );
  };

  const servicesBooked = (passedItems || cartItems || []).map((item) => ({
  serviceName: item.name || item.service_type || item.item_type || "Service",
  petName: item.petName || item.vendor_pet_name || item.pet_name || "",
  }));

  // ✅ Corrected total_price calculation in payload
  // const buildBookingPayload = () => ({
  //   order_type: "online",
  //   client_id: clientId,
  //   vendor_id: vendorID || guestvendorid,
  //   order_items: cartItems.map((item) => {
  //     const type = (item.service_type || item.item_type || "").toLowerCase();
  //     let total_price = 0;

  //     if (["home boarding", "kennel boarding", "pet resort"].includes(type)) {
  //       if (item.start_date && item.end_date) {
  //         const start = new Date(item.start_date);
  //         const end = new Date(item.end_date);
  //         const nights = Math.max(
  //           1,
  //           Math.ceil((end - start) / (1000 * 60 * 60 * 24))
  //         );
  //         total_price = (item.unit_price || 0) * nights;
  //       } else {
  //         total_price = item.unit_price || 0;
  //       }
  //     } else if (
  //       ["home grooming", "mobile pet grooming van", "grooming salon"].includes(
  //         type
  //       )
  //     ) {
  //       total_price = item.price || item.unit_price || 0;
  //     } else {
  //       const quantity = item.quantity || 1;
  //       total_price = (item.unit_price || 0) * quantity;
  //     }

  //     return {
  //       item_type: getItemType(item),
  //       vendor_pet_id: item.vendor_pet_id,
  //       service_id: item.service_id,
  //       room_id: item.room_id || null,
  //       room_type_id: item.room_type_id || null,
  //       technician_id: item.technician_id || null,
  //       start_date: formatDate(item.start_date),
  //       end_date: formatDate(item.end_date),
  //       time_range: item.time_range || null,
  //       duration: item.duration || 1,
  //       quantity: item.quantity || 1,
  //       unit_price: item.unit_price,
  //       discount: item.discount || 0,
  //       gst: item.gst || 0,
  //       total_price,
  //       addons: item.addons || [],
  //       description: item.description || "",
  //       sku_number: item.sku_number || "",
  //       vendor_pet_name: item.petName || "",
  //     };
  //   }),
  // });

  const buildBookingPayload = () => {
    // 1. Identify which items to use (prioritize items passed from Confirm page)
    const itemsToProcess = passedItems || cartItems;

    // 2. Map the items once
    const mappedItems = itemsToProcess.map((item, index) => {
      // const itemType = getItemType(item);
      const itemType = item.item_type || item.service_type || "other";

      // Nights/Duration Logic
      let durationValue = item.duration || 1;
      let quantityValue = 1; // Default quantity
      let nights = 1; // Default nights

      if (itemType === "boarding" && item.start_date && item.end_date) {
        const start = new Date(item.start_date);
        const end = new Date(item.end_date);
        nights = Math.max(1, Math.ceil((end - start) / (1000 * 60 * 60 * 24)));
        durationValue = nights;
        quantityValue = nights;

      } 
      else if (itemType === "day_care" || itemType === "dog_walking") {
        const rawDuration = item.duration || 1;
        durationValue = String(rawDuration).includes("hr") 
          ? rawDuration 
          : `${rawDuration}hr`;
        quantityValue = 1;
        nights = 1;
      } 
      else if (itemType === "grooming") {
        durationValue = item.duration || 1;
        quantityValue = 1;
        nights = 1;
      }

      // ── Use pre-calculated values from Confirm page (reliable) ──────
    const unitPrice    = Number(item.unit_price || item.price || 0);
    const discountAmt  = Number(item.discount_amount || 0);
    const taxAmt       = Number(item.tax_amount || 0);
    const amountNoTax  = Number(item.amount_without_tax || unitPrice);
    const afterDisc    = Number(item.amount_after_discount || amountNoTax - discountAmt);
    const withTax      = Number(item.amount_with_tax || item.total_price || afterDisc + taxAmt);

    return {
      item_type:       itemType,
      vendor_pet_id:   item.vendor_pet_id,
      service_id:      item.service_id || item.vendor_service_id,
      room_type_id:    item.room_type_id || null,
      room_id:         item.room_id || null,
      room_number:     item.room_number || "",
      start_date:      item.start_date,
      end_date:        item.end_date,
      time_range:      item.time_range || null,
      duration:        item.duration || "1",
      //quantity:       item.quantity || 1,
      quantity:        quantityValue|| 1,
      frequency:       item.frequency ? item.frequency.toLowerCase() : null,
      discounts:       item.discount,

      // ── Use the correct per-item values (no dividing!) ─────────────
      original_unit_price : unitPrice,
      unit_price:      afterDisc/(quantityValue || 1),   
      amount_without_tax: afterDisc,
      discount_amount:    discountAmt,
      amount_after_discount: afterDisc,
      tax_amount:         taxAmt,
      tax_percentage:     Number(item.tax_percentage || item.tax_rate || item.priceMeta?.taxPercentage || 0),
      amount_with_tax:    withTax,
      total_price:        withTax,
      gst:                taxAmt,    
      price_surcharge:  item.surcharge_details || [],      
      addons:             item.addons || [],
      notes:              item.notes || "",
    };
  });

  // Calculate aggregates from items (safer than trusting passed totals)
  let subtotal = 0, discTotal = 0, taxTotal = 0, grandTotal = 0;
   mappedItems.forEach(it => {
      subtotal   += it.amount_without_tax;
      discTotal  += it.discount_amount;
      //taxTotal   += it.tax_amount;
      //grandTotal += it.total_price;
    });
    const serviceDiscountTotal = passedItems.reduce(
    (sum, item) => sum + Number(item.discount_amount || 0),
    0
  );

  const orderDiscount = orderDiscountMeta?.discount_amount || 0;
  const finalAmountAfterDiscount =
    orderDiscountMeta?.amount_after_discount || passedSubtotal;

  const finalTax =
    orderDiscountMeta?.tax_amount_after_discount || passedTotalGST;

  const finalTotal = finalAmountAfterDiscount + finalTax;


  const resolvedVendorId =
    itemsToProcess[0]?.vendor_id ||
    guestvendorid ||
    itemsToProcess[0]?.shop_id ||
    vendorID;

  if (!resolvedVendorId) {
    toast.error("Vendor ID missing — cart corrupted");
    return null;
  }

  return {
    booking_type: 2,
    order_type: "online",
    client_id: clientId,
    vendor_id: resolvedVendorId,
    order_items: mappedItems,

    // Use summed values from items (most reliable)
    amount_before_discount: subtotal,
    discount_amount:        discTotal,
    //gst_after_discount:     taxTotal,
    //total_amount:           grandTotal,
    //amount_after_discount:  subtotal - discTotal,
    //paid_amount:            grandTotal,
    //total_paid_amount:      grandTotal,
       // ✅ FINAL SNAPSHOT
    //amount_before_discount: passedSubtotal,

    discount_amount:  orderDiscount,

    discount_type: orderDiscountMeta?.discount_type || null,
    discount_value: orderDiscountMeta?.discount_value || 0,

    amount_after_discount: finalAmountAfterDiscount,
    amount_without_tax: finalAmountAfterDiscount,

    gst_after_discount: finalTax,

    total_amount: finalTotal,

    total_discount: serviceDiscountTotal + orderDiscount,
    total_gst: finalTax,

    paid_amount: finalTotal,
    total_paid_amount: finalTotal,

    // ✅ CRITICAL
    order_discount: orderDiscountMeta
      ? {
          discount_type: orderDiscountMeta.discount_type,
          discount_value: orderDiscountMeta.discount_value,
          discount_amount: orderDiscountMeta.discount_amount,
        }
      : null,

    payment_mode:           selectedMethod,
    notes:                  "",
  };
};

  const handlePayment = async () => {
    if (!clientId)
      return toast.error("Client ID missing — please log in again");

    if (cartItems.length === 0 && !passedItems)
      return toast.error("Cart is empty");

    try {
      setLoading(true);
      const payload = buildBookingPayload();
      if (!payload) return; // Error handled inside buildBookingPayload

      const token = user?.token || localStorage.getItem("token");

      const response = await axios.post(
        `${config.API_BASE_URL}/customer/booking`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.status) {
        setOrderDetails({
          orderNumber: response.data.data?.order_number,
          orderId: response.data.data?._id,
          paidAmount: response.data.data?.total_paid_amount ?? totalAmount,
        });
        setSuccessMessage(
          `🎉 Booking successful! ID: ${response.data.data?._id}`
        );
        toast.success("Booking created successfully!");
        clearCart();
      } else {
        toast.error(response.data?.message || "Failed to create booking");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f6fb] flex justify-center py-10 px-4">
      {/* <div className="w-full max-w-5xl bg-white rounded-2xl shadow-2xl flex flex-col md:flex-row overflow-hidden border border-gray-100"> */}
        <div className="w-full flex justify-center py-10 px-4">
        {/* ✅ Success Message View */}
         {orderDetails ? (
          <div className="w-full min-h-[75vh] flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-50">
            <div className="max-w-xl w-full p-10 text-center">
              {/* Status Icon (Animated Watch) */}
              <div className="flex justify-center mb-6">
                <div className="relative w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center shadow-inner">
                  {/* Clock Circle */}
                  <svg
                    className="w-10 h-10 text-[#1e2a8a]"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="9" />
                  </svg>

                  {/* Center Dot */}
                  <span className="absolute w-2 h-2 bg-[#1e2a8a] rounded-full" />

                  {/* Rotating Hand */}
                  <span className="absolute w-[2px] h-5 bg-[#1e2a8a] origin-bottom animate-watch-hand" />
                </div>
              </div>

              {/* Headline */}
              <h2 className="text-3xl font-semibold tracking-tight text-gray-900 mb-2">
                Slot Reserved Successfully
              </h2>
              <p className="text-sm text-gray-500 mb-3">
                Order <span className="font-semibold text-[#1e2a8a]">#{orderDetails.orderNumber}</span>
              </p>

              {/* Sub headline */}
              <p className="text-gray-600 text-base mb-6 leading-relaxed">
                Your booking request has been sent to{" "}
                <span className="font-semibold text-[#1e2a8a]">
                  {brandName}
                </span>
                . The vendor will confirm availability shortly.
              </p>

              {/* Status Card */}
              <div className="bg-gray-50 border rounded-2xl p-5 text-left mb-6">
                <div className="flex justify-between items-center text-sm mb-3">
                  <span className="text-gray-500">Request Status</span>
                  <span className="px-3 py-1 rounded-full bg-orange-100 text-orange-700 font-medium text-xs">
                    Awaiting Vendor Confirmation
                  </span>
                </div>

                <div className="flex justify-between text-sm text-gray-600 mb-2">
                  <span>Amount Paid</span>
                  <span className="font-semibold text-gray-900">
                    ₹{totalAmount.toFixed(0)}
                  </span>
                </div>
              </div>

              {/* Support Text */}
              <p className="text-gray-600 text-sm leading-relaxed mb-8">
                You’ll be notified once the vendor responds. If the slot is
                unavailable, we’ll assist you with the next steps.
              </p>

              {/* CTA */}
              <button
                onClick={() => navigate("/")}
                className="w-full bg-[#1e2a8a] text-white py-3 rounded-xl font-semibold text-base shadow hover:bg-[#16236b] transition-all"
              >
                Back to Home
              </button>

              {/* Footer */}
              <p className="text-xs text-gray-400 mt-5">
                Thank you for choosing {brandName}
              </p>

              {/* Animation CSS */}
              <style>
                {`
          @keyframes watch-rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          .animate-watch-hand {
            animation: watch-rotate 1.8s linear infinite;
          }
        `}
              </style>
            </div>
          </div>
        ) : (
          // <>
          //   {/* Payment Options */}
          //   <div className="md:w-1/3 border-r border-gray-200 bg-gray-50">
          //     <h2 className="text-2xl font-semibold text-gray-800 px-6 py-5 border-b">
          //       Payment Options
          //     </h2>
          //     {["card", "upi", "paytm", "netbanking"].map((id) => (
          //       <div
          //         key={id}
          //         onClick={() => setSelectedMethod(id)}
          //         className={`px-6 py-3 cursor-pointer border-l-4 text-[16px] transition-all duration-200 ${
          //           selectedMethod === id
          //             ? "border-[#1e2a8a] bg-blue-50 text-[#1e2a8a] font-medium"
          //             : "border-transparent text-gray-700 hover:bg-gray-100"
          //         }`}
          //       >
          //         {id === "card"
          //           ? "💳 Debit / Credit Card"
          //           : id === "upi"
          //           ? "📱 UPI"
          //           : id === "paytm"
          //           ? "💰 Paytm Wallet"
          //           : "🏦 Net Banking"}
          //       </div>
          //     ))}
          //   </div>

          //   {/* Payment Form */}
          //   <div className="flex-1 p-8">
          //     <div className="flex justify-between items-center bg-[#1e2a8a] text-white rounded-md px-6 py-4 mb-6 shadow-sm">
          //       <h3 className="text-lg font-medium">Amount to Pay:</h3>
          //       <span className="text-xl font-bold">
          //         ₹{totalAmount.toFixed(0)}
          //       </span>
          //     </div>

          //     {selectedMethod === "card" && (
          //       <div className="bg-white border rounded-lg shadow-sm p-6 mb-6 transition-all">
          //         <input
          //           type="text"
          //           placeholder="Card Number"
          //           className="w-full border-b-2 mb-4 focus:border-[#1e2a8a] outline-none py-2 text-gray-700"
          //         />
          //         <input
          //           type="text"
          //           placeholder="Card Holder Name"
          //           className="w-full border-b-2 mb-4 focus:border-[#1e2a8a] outline-none py-2 text-gray-700"
          //         />
          //         <div className="flex gap-4">
          //           <input
          //             type="text"
          //             placeholder="MM / YY"
          //             className="w-1/2 border-b-2 focus:border-[#1e2a8a] outline-none py-2 text-gray-700"
          //           />
          //           <input
          //             type="password"
          //             placeholder="CVV"
          //             className="w-1/2 border-b-2 focus:border-[#1e2a8a] outline-none py-2 text-gray-700"
          //           />
          //         </div>
          //       </div>
          //     )}

          //     <button
          //       onClick={handlePayment}
          //       disabled={loading}
          //       className={`w-full bg-[#1e2a8a] text-white font-semibold py-3 rounded-md shadow-md transition-all ${
          //         loading
          //           ? "opacity-70 cursor-not-allowed"
          //           : "hover:bg-[#16236b]"
          //       }`}
          //     >
          //       {loading ? "Processing..." : `Pay ₹${totalAmount.toFixed(0)}`}
          //     </button>

          //     <div className="text-center text-sm text-gray-500 mt-6 italic">
          //       🔒 Your transactions are 100% secure and encrypted
          //     </div>
          //   </div>
          // </>

          <div className="w-full flex justify-center py-10">
          <div className="w-full max-w-md bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden text-center">

            {/* Amount hero */}
            <div className="pt-8 pb-6 px-6">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                <span className="text-4xl">💵</span>
              </div>
              <p className="text-sm text-gray-500 mb-1">Amount payable in cash</p>
              <p className="text-3xl font-semibold text-gray-900">
                ₹{totalAmount.toFixed(0)}
              </p>
            </div>

            {/* Booking details */}
            <div className="px-6 pb-6 text-left">
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-xs text-gray-400 mb-1">Booking with</p>
                <p className="text-[15px] font-medium text-gray-900 mb-3">
                  {brandName}
                </p>

                {servicesBooked.map((s, idx) => (
                  <div
                    key={idx}
                    className="flex justify-between text-sm py-1"
                  >
                    <span className="text-gray-500">{s.serviceName}</span>
                    <span className="text-gray-800">{s.petName}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Confirm */}
            <div className="px-6 pb-8">
              <button
                onClick={handlePayment}
                disabled={loading}
                className={`w-full bg-[#1e2a8a] text-white font-semibold py-3 rounded-md shadow-md transition-all ${
                  loading ? "opacity-70 cursor-not-allowed" : "hover:bg-[#16236b]"
                }`}
              >
                {loading ? "Processing..." : "book Now"}
              </button>
              <p className="text-xs text-gray-400 mt-3">
                You'll pay the vendor directly when the service is complete
              </p>
            </div>

          </div>
        </div>
        )}
      </div>
    </div>
  );
};
export default PaymentPage;
